let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2myh5")).then(() => parcelRequire('7EAYF'));